module.exports = __webpack_public_path__ + "img/drawing@2x.934fbc7.jpg";